import { useEffect, useState } from 'react';
import { getApi } from '../../../../api/call.api';
import { urlApi } from '../../../../api/url.api';
import { loadingHide, loadingShow } from '../../../../loadingUi/loading.controller';

const ChatSessionSidebar = ({ visitorData, onUserTileClick }) => {


    const [chatSessionList, setChatSessionList] = useState([])

    const getChatSessionList = async () => {
        loadingShow();
        let resp = await getApi(urlApi.getVisitorsPreviousChatSessions + visitorData?.visitorId);
        loadingHide();
        if (resp.responseCode === 200) {
            setChatSessionList(resp.data)
        } else {
            setChatSessionList([])
        }
    }

    useEffect(() => {
        getChatSessionList();

        return () => {
            setChatSessionList([]);
        }
    }, [visitorData?.visitorId])


    return (
        <div className='w-max px-3 py-2'>
            <h5>Chat Session History</h5>
            {
                chatSessionList.length > 0 ? (
                    <div className='flex flex-col gap-2 mt-2 max-h-[calc(100vh-130px)] overflow-y-auto'>
                        {chatSessionList.map((session, index) => (
                            <div key={index} className='p-2 border rounded-md hover:bg-gray-100 transition cursor-pointer' onClick={() => onUserTileClick(session)}>
                                <p className='text-sm font-semibold'>Session #{session.chatSessionCount}</p>
                                <p className='text-xs text-gray-500'>Started At: {new Date(session.createdAt).toLocaleString()}</p>
                                <p className='text-xs text-gray-500'>Status: {session.status == 1 ? "Open" : session.status == 2 ? "Pending" : session.status == 3 ? "Resolved" : session.status == 4 ? "Closed" : "N/A"}</p>
                            </div>
                        ))}
                    </div>
                ) : (
                    <p className='text-xs text-gray-500 mt-2'>No chat sessions found.</p>
                )
            }
        </div>
    )
}

export default ChatSessionSidebar